import {
  AddAdditionalContact,
  AddAdditionalEmail,
  Notificationdropdown,
} from "components";
import SC from "./style";
import { Chip, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { saveOptionData } from "utils/optionData/utils";
import { useEffect, useState } from "react";
import { Button, Loader } from "@InnoUI/";
import theme from "@theme/";
import { parseEmails } from "utils/helper";

const NotificationContent = (props) => {
  const { setData, data, loading } = props;
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const [openModalView, setOpenModalView] = useState(false);
  const [openEmailModalView, setOpenEmailModalView] = useState(false);

  const getAddressBookProjectId = () => {
    if (type != 1) {
      return projectId;
    }

    const linkedOccupants = Array.isArray(data?.linktoproject)
      ? data.linktoproject
      : [data?.linktoproject];

    return [...new Set([projectId, ...linkedOccupants].filter(Boolean))];
  };

  useEffect(() => {
    setData((prevData) => ({
      ...prevData,
      saveOption: 0,
    }));
  }, []);

  const handleChange = (property, value) => {
    const parsedValue = property === "saveOption" ? Number(value) : value;

    if (property === "saveOption" && value == 1) {
      setData((prevData) => ({
        ...prevData,
        sendTo: "",
        sendCc: "",
        sendBcc: "",
        AdditionalEmailTo: [],
        AdditionalEmailCc: [],
        AdditionalEmailBcc: [],
      }));
    }

    setData((prevData) => {
      let updatedValue = parsedValue;

      if (["sendTo", "sendCc", "sendBcc"].includes(property)) {
        const additionalEmailsMap = {
          sendTo: prevData.AdditionalEmailTo || [],
          sendCc: prevData.AdditionalEmailCc || [],
          sendBcc: prevData.AdditionalEmailBcc || [],
        };

        // Ensure `parsedValue` is an array (in case it's coming from a dropdown)
        const newEmails = Array.isArray(parsedValue)
          ? parsedValue
          : parsedValue
              .split(",")
              .map((email) => email.trim())
              .filter(Boolean); // Remove empty values

        // Merge dropdown values with additional emails and remove duplicates
        const updatedEmailsSet = new Set([
          ...newEmails,
          ...additionalEmailsMap[property],
        ]);
        const updatedEmailsArray = Array.from(updatedEmailsSet).filter(Boolean); // Remove empty values

        updatedValue = updatedEmailsArray.join(", "); // Convert array to comma-separated string without extra commas
      }

      return {
        ...prevData,
        [property]: updatedValue,
      };
    });
  };

  const openModal = () => {
    setOpenModalView(true);
  };

  const handleCloseModal = () => {
    setOpenModalView(false);
  };
  const openEmailModal = () => {
    setOpenEmailModalView(true);
  };

  const toEmails = parseEmails(data?.sendTo);
  const ccEmails = parseEmails(data?.sendCc);
  const bccEmails = parseEmails(data?.sendBcc);

  const handleDelete = (emailToRemove, fieldKey) => {
    setData((prevData) => {
      // Remove email from the specified field (To, Bcc, or Cc)
      const updatedEmails = prevData[fieldKey]?.filter(
        (email) => email !== emailToRemove,
      );

      // Remove email from sendTo, sendBcc, or sendCc (if applicable)
      const sendKey = fieldKey.replace("AdditionalEmail", "send"); // Convert AdditionalEmailTo -> sendTo
      const updatedSendEmails = prevData[sendKey]
        ?.split(", ")
        .filter((email) => email !== emailToRemove)
        .join(", ");

      return {
        ...prevData,
        [fieldKey]: updatedEmails, // Update dynamic field (To, Bcc, or Cc)
        [sendKey]: updatedSendEmails || "", // Update send field (if applicable)
      };
    });
  };

  return (
    <SC.Container>
      {loading && (
        <SC.LoaderContainer>
          <Loader />
        </SC.LoaderContainer>
      )}
      <SC.LabelContainer>
        <SC.Label>Save Option</SC.Label>
        <SC.Children>
          <SC.Wrapper>
            <RadioGroup
              row
              value={data?.saveOption}
              onChange={(e) => handleChange("saveOption", e.target.value)}
            >
              {saveOptionData.map((option) => (
                <FormControlLabel
                  key={option.id}
                  value={option.id}
                  control={
                    <Radio
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        "&.Mui-checked": {
                          color: "#EC810B",
                        },
                        margin: "0px 0px 0px 10px",
                      }}
                    />
                  }
                  label={option.label}
                />
              ))}
            </RadioGroup>
          </SC.Wrapper>
        </SC.Children>
      </SC.LabelContainer>

      {data?.saveOption == 0 && (
        <>
          <div
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center",
              gap: "100px",
            }}
          >
            <p
              style={{
                fontWeight: "bold",
                fontSize: "12px",
                margin: "20px 15px 20px 0px",
              }}
            >
              Email Notifiction Recipients
            </p>
            <SC.ButtonContainer>
              <Button
                caption="Add Email Contact"
                fontSize="12px"
                color="white"
                style={{
                  marginBottom: 8,
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "100px",
                  borderRadius: "3px",
                  height: "30px",
                  fontSize: "12px",
                }}
                onClick={openEmailModal}
              />
              <Button
                caption="Add Contact"
                fontSize="12px"
                color="white"
                style={{
                  marginBottom: 8,
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "100px",
                  borderRadius: "3px",
                  height: "30px",
                  fontSize: "12px",
                }}
                onClick={openModal}
              />
            </SC.ButtonContainer>
          </div>
          {/* Alarm Recipient(s) */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <SC.LabelContainer>
              <SC.Label>To</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <Notificationdropdown
                    defaultValue={data?.sendTo || ""}
                    name="sendTo"
                    onChange={handleChange}
                    projectId={getAddressBookProjectId()}
                    type={type}
                    width="100%"
                    disabledValues={data?.users}
                    disabledEmails={[...ccEmails, ...bccEmails]}
                    maxTagCount={3}
                    placeholder={"Select To Recipient"}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>
            <div style={{ flex: 1, marginLeft: "10px" }}>
              {data?.AdditionalEmailTo?.map((email, index) => (
                <Chip
                  key={index}
                  label={email}
                  variant="outlined"
                  onDelete={() => handleDelete(email, "AdditionalEmailTo")}
                  sx={{
                    margin: "2px",
                    backgroundColor: "#f0f0f0",
                    color: "#333",
                    fontSize: "12px",
                    height: "25px",
                  }}
                />
              ))}
            </div>
          </div>
          {/* Alarm Recipient(s) */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <SC.LabelContainer>
              <SC.Label>Cc</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <Notificationdropdown
                    defaultValue={data?.sendCc || ""}
                    name="sendCc"
                    onChange={handleChange}
                    projectId={getAddressBookProjectId()}
                    type={type}
                    width="100%"
                    disabledEmails={[...toEmails, ...bccEmails]}
                    maxTagCount={3}
                    placeholder={"Select Cc Recipient"}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>
            <div style={{ flex: 1, marginLeft: "10px" }}>
              {data?.AdditionalEmailCc?.map((email, index) => (
                <Chip
                  key={index}
                  label={email}
                  variant="outlined"
                  onDelete={() => handleDelete(email, "AdditionalEmailCc")}
                  sx={{
                    margin: "2px",
                    backgroundColor: "#f0f0f0",
                    color: "#333",
                    fontSize: "12px",
                    height: "25px",
                  }}
                />
              ))}
            </div>
          </div>
          {/* Alarm Recipient(s) */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <SC.LabelContainer>
              <SC.Label>Bcc</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <Notificationdropdown
                    defaultValue={data?.sendBcc || ""}
                    name="sendBcc"
                    onChange={handleChange}
                    projectId={getAddressBookProjectId()}
                    type={type}
                    width="100%"
                    disabledEmails={[...toEmails, ...ccEmails]}
                    maxTagCount={3}
                    placeholder={"Select Bcc Recipient"}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>
            <div style={{ flex: 1, marginLeft: "10px" }}>
              {data?.AdditionalEmailBcc?.map((email, index) => (
                <Chip
                  key={index}
                  label={email}
                  variant="outlined"
                  onDelete={() => handleDelete(email, "AdditionalEmailBcc")}
                  sx={{
                    margin: "2px",
                    backgroundColor: "#f0f0f0",
                    color: "#333",
                    fontSize: "12px",
                    height: "25px",
                  }}
                />
              ))}
            </div>
          </div>
          {openEmailModalView && (
            <AddAdditionalEmail
              openEmailModalView={openEmailModalView}
              setOpenEmailModalView={setOpenEmailModalView}
              setData={setData}
              data={data}
            />
          )}

          {openModalView && (
            <AddAdditionalContact
              openModalView={openModalView}
              onClose={handleCloseModal}
              setPropData={setData}
            />
          )}
        </>
      )}
    </SC.Container>
  );
};

export default NotificationContent;
